import Action from "../actions";

export function setUserReversedInfoReducer(state = [], action) {

    if (action.type === Action.SET_USER_REVERSED_INFO) {
        return action.userReversedInfo;
    }
    return state;
}
